module.exports = __webpack_public_path__ + "img/ylb-en1.3ed0502f.png";